import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import validator from 'validator'
import update from 'immutability-helper'
import { withRouter } from 'react-router-dom'

import './ResetPassword.scss'
import * as Router from '../../../shared/router'
import PasswordField from '../../../components/Form/PasswordField/PasswordField'
import branding from '../../../shared/branding'
import { ChangePasswordAPI } from '../../../api/User/ChangePassword'
import { UserChangePasswordAPI } from '../../../api/User/UserChangePassword'
import FormHandler from '../../../factory/FormHandler'
import toastCenter, { toastMessageType } from '../../../shared/toastCenter'
import LogoLogin from '../Logo.png'
import hero1 from '../hero.jpg'
import Spinner from '../../../components/Loader/Spinner/Spinner'
import { useQuery } from '../../../shared/utility'

const ResetPassword = ({ history }) => {
  let query = useQuery()
  let token = query.get('token')
  let userType = query.get('type')
  let email = query.get('email')

  const defaultValueInput = {
    value: '',
    isEmpty: false,
    isInvalid: false,
  }

  const [password, setPassword] = useState(defaultValueInput)
  const [retypePassword, setRetypePassword] = useState(defaultValueInput)
  const [isSendedResetPassword, setIsSendedResetPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [pageLoading, setPageLoading] = useState(true)

  useEffect(() => {
    if (token && userType && email) {
      setPageLoading(false)
    } else {
      history.push(Router.signin)
    }
  }, [history, token, userType, email])

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSubmit()
    }
  }

  const handleSubmit = () => {
    if (
      password.isEmpty ||
      retypePassword.isEmpty ||
      password.isInvalid ||
      retypePassword.isInvalid ||
      validator.isEmpty(password.value) ||
      validator.isEmpty(retypePassword.value)
    ) {
      return
    } else {
      const data = new FormHandler()
      data.append('token', token)
      data.append('type', userType)
      data.append('email', email)
      data.append('newPassword', password.value)
      data.append('reNewPassword', retypePassword.value)

      setIsLoading(true)

      const onNext = (response) => {
        if (response.success) {
          setIsSendedResetPassword(true)
        } else {
          let message = response.messages
            ? response.messages
            : response.message
            ? response.message
            : 'Someting went wrong'
          toastCenter.message('Failed', message, toastMessageType.ERROR, false)
        }
      }
      const onComplete = () => {
        setIsLoading(false)
      }
      const onError = () => {
        toastCenter.messageServerError()
      }

      const changePasswordAPI =
        userType === 'user'
          ? new UserChangePasswordAPI()
          : new ChangePasswordAPI()
      changePasswordAPI.subscribe(data.all(), onNext, onComplete, onError)
    }
  }

  const handleChangePassword = (e) => {
    setPassword(
      update(password, {
        value: { $set: e.target.value },
        isEmpty: { $set: validator.isEmpty(e.target.value) },
        isInvalid: {
          $set:
            !validator.isEmpty(e.target.value) &&
            !validator.isLength(e.target.value, { min: 6, max: 20 }),
        },
      })
    )
  }

  const handleChangeRetypePassword = (e) => {
    setRetypePassword(
      update(retypePassword, {
        value: { $set: e.target.value },
        isEmpty: { $set: validator.isEmpty(e.target.value) },
        isInvalid: {
          $set:
            !validator.isEmpty(e.target.value) &&
            (!validator.isLength(e.target.value, { min: 6, max: 20 }) ||
              password.value !== e.target.value),
        },
      })
    )
  }

  return (
    <div className="reset-password-wrapper h-100 overflow-hidden">
      <Helmet>
        <title>{branding.NAME} - Reset Password</title>
      </Helmet>

      {pageLoading ? (
        <Spinner isLoading={true} />
      ) : (
        <>
          {isLoading && <Spinner isLoading={true} />}
          <div className="header">
            <div className="container-fluid container-custom position-relative h-100">
              <div className="row">
                <div className="col-md-6 pr-5 left">
                  <div className="d-flex">
                    <div className="flex-fill logo d-flex align-items-center">
                      {branding.NAME === 'ngine' && (
                        <a
                          href={branding.DOMAIN}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={LogoLogin} className="logo" alt="" />
                        </a>
                      )}
                    </div>

                    {/* {branding.NAME === 'ngine' && (
                                <div className="flex-fill d-flex flex-row justify-content-end align-items-center ml-auto nav-item">
                                  <span className="nobreak d-md-inline  d-sm-inline  d-md-inline  d-lg-inline  d-xl-inline">
                                    Want an account?
                                  </span>
                                  <a
                                    className="btn btn-lg btn-link btn-register ml-1"
                                    href={branding.REGISTER}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Start Free Trial
                                  </a>
                                </div>
                              )} */}
                  </div>
                </div>

                <div className="col-6 col-sm-6">&nbsp;</div>
              </div>
            </div>
          </div>

          <div className="form-signin">
            <div className="container-fluid position-relative">
              <div className="row d-flex h-100 align-items-end z-1 position-relative flex-row justify-content-end justify-content-md-start">
                <div className="col-12 order-2 order-sm-1 col-sm-6 section-content">
                  {isSendedResetPassword ? (
                    <>
                      <p>Great, your password has already been set.</p>
                      <a
                        href={
                          userType === 'user'
                            ? Router.signinAdmin
                            : Router.signin
                        }
                        className="btn btn-lg btn-darkprimary btn-reset-password btn-send-email"
                      >
                        Login
                      </a>
                    </>
                  ) : (
                    <>
                      <h1>Reset Password</h1>
                      <p>Enter a new password for your account.</p>
                      <div className="form-field-wrapp">
                        <PasswordField
                          label="Password"
                          formClassName="passsword-form-group"
                          placeholder="Enter Password…"
                          id="password"
                          onKeyDown={handleKeyDown}
                          isRequired
                          maxLength={20}
                          autoComplete="password"
                          isInvalid={password.isInvalid}
                          isEmpty={password.isEmpty}
                          onChange={handleChangePassword}
                          value={password.value}
                        />
                        <PasswordField
                          label="Retype Password"
                          formClassName="passsword-form-group"
                          placeholder="Retype Password…"
                          id="retype-password"
                          onKeyDown={handleKeyDown}
                          isRequired
                          maxLength={20}
                          autoComplete="retype-password"
                          isInvalid={retypePassword.isInvalid}
                          isEmpty={retypePassword.isEmpty}
                          onChange={handleChangeRetypePassword}
                          value={retypePassword.value}
                        />
                      </div>

                      <br />

                      <div className="d-flex flex-row justify-content-left align-items-left">
                        <button
                          type="button"
                          className="btn btn-darkprimary btn-block rounded-pill btn-login"
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </>
                  )}
                </div>

                <div className="col-6 order-1 order-sm-2 col-sm-6 section-img px-0">
                  <img src={hero1} alt="" />
                </div>
              </div>
            </div>
          </div>

          <footer className="footer py-3">
            <div className="container-fluid container-custom">
              <div className="row">
                <div className="col-lg-6 col-sm-12">
                  <div className="d-flex align-items-center copyright">
                    {branding.NAME === 'ngine' && (
                      <span>
                        Copyright © 2022 <i>ngine</i>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </>
      )}
      <div className="ornament"></div>
    </div>
  )
}

export default withRouter(ResetPassword)
